<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Button } from '@shared/ui/buttons/button';

  import PaginateNav from './paginate.svelte';

  const dispatch = createEventDispatcher();

  export let totalItems: number;
  export let pageSize: number;
  export let currentPage = 1;
  export let loadMore = 0;

  // $: isShouldLoadMore = Boolean(Math.floor(totalItems / pageSize) > currentPage - 1 + loadMore);

  function setPageHandler(e: CustomEvent) {
    currentPage = e.detail.page;
    loadMore = 0;

    dispatch('onPageChange', {
      currentPage,
    });
  }

  function loadMoreHandler() {
    loadMore += 1;
    dispatch('onLoadMore', {
      loadMore,
      currentPage,
    });
  }
</script>

{#if totalItems > pageSize}
  {@const maxPage = Math.ceil(totalItems / pageSize)}
  {@const page = currentPage + loadMore}

  <div class="mb-12 flex flex-wrap justify-center">
    <div class="w-full md:w-2/12" class:invisible="{page >= maxPage}">
      <Button class="!rounded-lg font-bold" variant="secondary" size="md" on:click="{loadMoreHandler}">
        <span class="font-bold"> Load More </span>
      </Button>
    </div>
    <div class="w-full"></div>
  </div>

  <!-- {#if isShouldLoadMore}
    <div
      use:inview="{{ rootMargin: '100px' }}"
      on:inview_enter="{(e) => {
        if (e.detail.scrollDirection.vertical === 'up') {
          loadMoreHandler();
        }
      }}"
      class="absolute bottom-0"
    ></div>
  {/if} -->

  <PaginateNav
    {totalItems}
    {pageSize}
    limit="{1}"
    currentPage="{currentPage + loadMore}"
    showStepOptions="{true}"
    on:setPage="{setPageHandler}"
  />
{/if}
